import React, {useCallback, useEffect, useState} from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
export const debtMoney = amount => new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(amount);
export const debtDate = value => new Intl.DateTimeFormat('de-DE', {
  dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Berlin',
}).format(new Date(value));

export function useBalanceDeadline(employeeId, departmentId) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    let alive = true;
    let pending = false;
    setData(null); setError(false);
    if (!employeeId || !departmentId) return undefined;
    const load = async () => {
      if (pending) return;
      pending = true;
      try {
        const response = await axios.get(`${API}/departments/${departmentId}/employees/${employeeId}/debt-status`);
        if (alive) {setData(response.data); setError(false);}
      } catch (_) {if (alive) setError(true);}
      finally {pending = false;}
    };
    load();
    const timer = window.setInterval(load, 30000);
    window.addEventListener('focus', load);
    return () => {alive = false; window.clearInterval(timer); window.removeEventListener('focus', load);};
  }, [employeeId, departmentId, revision]);
  return {data, error, refresh, unavailable: !data || error};
}

export function BalanceDeadlineMessage({data, error, refresh}) {
  if (error) return <div role="alert" className="my-3 rounded-lg bg-amber-50 p-4 text-sm text-amber-900">
    Der Zahlungsstatus konnte nicht aktualisiert werden. <button type="button" onClick={refresh} className="underline">Erneut prüfen</button>
  </div>;
  if (!data || data.state === 'clear') return null;
  return <div role="status" className={`my-3 rounded-lg border p-4 ${data.blocked ? 'border-red-200 bg-red-50 text-red-900' : 'border-amber-200 bg-amber-50 text-amber-900'}`}>
    <p className="font-semibold">{data.blocked ? 'Zahlungsfrist abgelaufen – Bestellungen gesperrt' : 'Bitte deinen Saldo begleichen'}</p>
    <p className="mt-1 text-sm">Offener Betrag: <strong>{debtMoney(data.debt)}</strong>.</p>
    <p className="mt-1 text-sm">{data.blocked
      ? <>Bitte deinen Saldo ausgleichen. Die Zahlungsfrist endete am <strong>{debtDate(data.due_at)} Uhr</strong>.</>
      : <>Bitte bis <strong>{debtDate(data.due_at)} Uhr</strong> ausgleichen.</>}</p>
    <button type="button" onClick={refresh} className="mt-2 text-sm underline">Zahlungsstatus aktualisieren</button>
  </div>;
}

export default function BalanceDeadlineNotice({employeeId, departmentId}) {
  const status = useBalanceDeadline(employeeId, departmentId);
  return <BalanceDeadlineMessage {...status} />;
}
